import { render, staticRenderFns } from "./multipleChoiceMulit.vue?vue&type=template&id=e40ac286&scoped=true&"
import script from "./multipleChoiceMulit.vue?vue&type=script&lang=js&"
export * from "./multipleChoiceMulit.vue?vue&type=script&lang=js&"
import style0 from "./multipleChoiceMulit.vue?vue&type=style&index=0&id=e40ac286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40ac286",
  null
  
)

export default component.exports